export default __webpack_public_path__ + "static/media/hdProLogoVectorDark.016a2501.svg";